import React, { useContext } from 'react';
import styled from 'styled-components';
import { Button } from 'components';
import { LocalContext } from 'context';
import { clearQueryParams } from 'utils';
import { FormContainer } from '../FormComponents';

const ActionCodeError = ({ actionCodeError, setActionCodeError }) => {
  const { theme } = useContext(LocalContext);

  return (
    <CustomContainer theme={theme}>
      <ModalTitle
        dangerouslySetInnerHTML={{
          __html: actionCodeError.message
        }}
      />
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          onClick={() => {
            clearQueryParams();
            setActionCodeError({ mode: null, message: null });
          }}
          type="button"
          width="8.125rem"
          style={{ alignSelf: 'center', marginTop: '1.5rem' }}>
          Close
        </Button>
      </div>
    </CustomContainer>
  );
};

const ModalTitle = styled.h3`
  text-align: center;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
`;

const CustomContainer = styled(FormContainer)`
  max-width: 450px;
  margin-top: 20px;
  margin-bottom: 20px;

  @media screen and (min-width: 1150px) {
    padding: 40px 20px;
  }
`;

export default ActionCodeError;
